export default {
  examsList: [],
}
